import { c as _c } from "react/compiler-runtime";
import { Card, Padding, Text, Flexbox, Spacing, PopoverAnimation, Button } from '@newfront-insurance/core-ui';
import type { ReactNode, JSX } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { ErrorDetails } from './error-details';
import { ErrorIcon } from './error-icon';
import type { NextApiError } from '../../../next-api-error/error';
interface Props {
  title: string;
  body: ReactNode;
  error: NextApiError | Error;
}

/**
 * Render a large error that can be used when a page resource fails to load.
 * @param props
 */
export function ErrorCard(props) {
  const $ = _c(22);
  const {
    title,
    body,
    error
  } = props;
  const [showDetails, setShowDetails] = useState(false);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maxWidth: 500
    };
    t1 = <ErrorIcon />;
    t2 = <Spacing height={16} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <Text textAlign="center" color="dark" weight={600}>{title}</Text>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Spacing height={4} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== body) {
    t5 = <Text textAlign="center">{body}</Text>;
    $[6] = body;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Spacing height={24} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== showDetails) {
    t7 = () => setShowDetails(!showDetails);
    $[9] = showDetails;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = showDetails ? "Less information" : "More information";
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <Button size="secondary" onClick={t7}>{t8}</Button>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== error || $[15] !== showDetails) {
    t10 = showDetails ? <><Spacing height={24} /><ErrorDetails error={error} /></> : null;
    $[14] = error;
    $[15] = showDetails;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t3 || $[19] !== t5 || $[20] !== t9) {
    t11 = <StyledErrorContainer><PopoverAnimation isOpen={true} direction="up"><Card><Padding size={24}><Flexbox justifyContent="center" alignItems="center" flexDirection="column" style={t0}>{t1}{t2}{t3}{t4}{t5}{t6}{t9}{t10}</Flexbox></Padding></Card></PopoverAnimation></StyledErrorContainer>;
    $[17] = t10;
    $[18] = t3;
    $[19] = t5;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
const StyledErrorContainer = styled.div`
  width: 500px;
  margin: 100px auto;
`;